(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/react/set-deposit-confirm-limits.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/react/set-deposit-confirm-limits.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Button = svs.ui.ReactButton;
const HighLimitNote = svs.accountservicesReact.gameLimitDepositsForm.HighLimitNote;
const _svs$accountservicesR = svs.accountservicesReact.gameLimitDepositsForm.tracking,
  trackingAccept = _svs$accountservicesR.trackingAccept,
  trackingLimit = _svs$accountservicesR.trackingLimit,
  eventActions = _svs$accountservicesR.eventActions;
const setDepositLimitAsync = svs.accountservicesReact.gameLimitDepositsForm.service.setDepositLimitAsync;
const SetDepositLimitsConfirm = _ref => {
  let dayLimit = _ref.dayLimit,
    monthLimit = _ref.monthLimit,
    handleGoBack = _ref.handleGoBack,
    weekLimit = _ref.weekLimit,
    onSaved = _ref.onSaved;
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isButtonDisabled = _React$useState2[0],
    setIsButtonDisabled = _React$useState2[1];
  const _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isBackButtonDisabled = _React$useState4[0],
    setIsBackButtonDisabled = _React$useState4[1];
  const customerServicePhone = '0770 - 11 11 11';
  const showSaveDepositLimitsErrorDialog = () => {
    const text = "\n       <p>Ett fel uppstod i samband med hantering av ins\xE4ttningsgr\xE4nserna.</p>\n       <p>F\xF6rs\xF6k igen eller kontakta Kundservice ".concat(customerServicePhone, "</p>\n    ");
    const dialog = new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      type: svs.ui.dialog.type.ERROR,
      title: 'Ett fel har uppstått',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text
      }],
      actions: [{
        title: 'Okej'
      }]
    });
    svs.ui.dialog.api.add(dialog);
  };
  const saveDepositLimitsAsync = async (limitTypesArray, depositBudgetsArray) => {
    const _await$setDepositLimi = await setDepositLimitAsync(limitTypesArray, depositBudgetsArray),
      error = _await$setDepositLimi.error,
      data = _await$setDepositLimi.data;
    if (!error && data) {
      const limits = data.limits;
      return {
        error: null,
        data: limits
      };
    }
    return {
      error,
      data
    };
  };
  const saveLimits = async () => {
    if (isButtonDisabled) {
      return;
    }
    setIsButtonDisabled(true);
    const limitTypesArray = ['DAY', 'WEEK', 'MONTH'];
    const depositBudgetsArray = [
    svs.utils.format.CurrencyAsJupiterString(dayLimit),
    svs.utils.format.CurrencyAsJupiterString(weekLimit),
    svs.utils.format.CurrencyAsJupiterString(monthLimit)];
    const _await$saveDepositLim = await saveDepositLimitsAsync(limitTypesArray, depositBudgetsArray),
      error = _await$saveDepositLim.error,
      savedLimits = _await$saveDepositLim.data;
    if (error) {
      showSaveDepositLimitsErrorDialog();
      setIsButtonDisabled(false);
    } else {
      trackingAccept(eventActions.CONFIRM);
      trackingLimit();
      setIsButtonDisabled(false);
      onSaved(savedLimits);
    }
  };
  const goBack = async () => {
    if (isBackButtonDisabled) {
      return;
    }
    setIsBackButtonDisabled(true);
    trackingAccept(eventActions.CANCEL);
    handleGoBack();
    setIsButtonDisabled(false);
  };
  return React.createElement("div", {
    className: "padding-bottom-1"
  }, React.createElement("div", null, React.createElement("p", {
    className: "padding-bottom-1 align-left"
  }, "Det h\xE4r \xE4r vad du som mest kan s\xE4tta in p\xE5 ditt spelkonto:"), React.createElement("p", {
    className: "align-left f-bold f-700"
  }, svs.utils.format.Currency(monthLimit), " ", React.createElement("abbr", {
    "aria-label": "kronor",
    title: "kronor"
  }, "kr"), " per m\xE5nad"), React.createElement("p", {
    className: "align-left f-bold f-700"
  }, svs.utils.format.Currency(weekLimit), " ", React.createElement("abbr", {
    "aria-label": "kronor",
    title: "kronor"
  }, "kr"), " per vecka"), React.createElement("p", {
    className: "align-left f-bold f-700 margin-bottom-2"
  }, svs.utils.format.Currency(dayLimit), " ", React.createElement("abbr", {
    "aria-label": "kronor",
    title: "kronor"
  }, "kr"), " per dag"), React.createElement(HighLimitNote, {
    dayLimit: dayLimit,
    monthLimit: monthLimit,
    weekLimit: weekLimit
  })), React.createElement(Button, {
    block: true,
    className: "margin-xs-bottom-1 margin-md-bottom-1",
    disabled: isButtonDisabled,
    focus: true,
    onClick: saveLimits
  }, "Spara ins\xE4ttningsgr\xE4nser"), React.createElement(Button, {
    block: true,
    disabled: isBackButtonDisabled,
    onClick: goBack,
    transparent: true
  }, "\xC4ndra ins\xE4ttningsgr\xE4nser"));
};
svs.accountservicesReact.gameLimitDepositsForm.SetDepositLimitsConfirm = SetDepositLimitsConfirm;

 })(window);